export const createGetTimeSlotInstancesRequest = () => {
    return {
        url: "/time_slot_instances",
        method: "GET"
    };
}

export const createSaveTimeSlotInstanceRequest = (day_of_the_month, month, year, time_slot_id, post_id) => {
    return {
        url: "/time_slot_instances",
        method: "POST",
        data: {
            day_of_the_month,
            month,
            year,
            time_slot_id,
            post_id,
        },
    };
}

export const createSaveTimeSlotInstanceRequestWithoutTimeSlot = (day_of_the_month, month, year, day_of_week, hour, minute, post_id) => {
    return {
        url: "/time_slot_instances",
        method: "POST",
        data: {
            day_of_the_month,
            month,
            year,
            day_of_week,
            hour,
            minute,
            post_id,
        },
    };
}

export const createDeleteTimeSlotInstanceRequest = (id) => {
    return {
        url: "/time_slot_instances/" + id,
        method: "DELETE",
    };
}
